import React from 'react';
import { FormattedNumber, FormattedDate } from 'react-intl';
import { FormatMoney } from 'common/helpers/numberHelper';
import { getTemplateString, isNullOrWhiteSpace } from 'common/helpers/string';
import styles from './RepaymentList.module.scss';
import { useAppSelector } from 'app/hooks';
import { selectCurrentMarket } from 'features/core/selectors';
import { Market } from 'common/consts/markets';
import classNames from 'classnames';
interface Props {
  Heading?: string;
  Monthlylabel: string;
  Mothlyamount: any;
  BalanceLabel?: string;
  BalanceAmount?: any;
  DiscountBalancelabel?: string;
  DiscountBalanceAmount?: any;
  Finallabel?: string;
  FinalAmount?: any;
  Totaltext: string;
  Totalamount: any;
  Currencysymbol?: any;
  IsCurrencyOnTheLeftSide?: any;
  Decimalseparator?: any;
  DisposableIncomeLimit?: any;
  NumberofMonth?: any;
  PaymentMethodLabel?: string;
  PaymentMethod?: any;
  CustomerNumberLabel?: string;
  CustomerNumber?: any;
  PlanDueDate?: any;
  PlanDueDateInfoText?: any;
  UpdatePlanConfirm?: boolean;
  DiscountedDebtBalanceRaw?: any;

}

const RepaymentList = ({
  Heading,
  Monthlylabel,
  Mothlyamount,
  BalanceLabel,
  BalanceAmount,
  DiscountBalancelabel,
  DiscountBalanceAmount,
  Finallabel,
  FinalAmount,
  Totaltext,
  Totalamount,
  Currencysymbol,
  IsCurrencyOnTheLeftSide,
  Decimalseparator,
  DisposableIncomeLimit,
  NumberofMonth,
  PaymentMethodLabel,
  PaymentMethod,
  CustomerNumberLabel,
  CustomerNumber,
  PlanDueDate,
  PlanDueDateInfoText,
  UpdatePlanConfirm,
  DiscountedDebtBalanceRaw,
}: Props) => {
  const hasLimitClass = DisposableIncomeLimit ? 'has-limit' : '';
  const planDueDateTemplate = getTemplateString(PlanDueDateInfoText);
  const currentMarket = useAppSelector(selectCurrentMarket);
  return (
    <>
      <section className="CreateRepaymentPlan__section">
        <div className="repaymentPlan">
          <h3 className="repaymentPlan__heading">
            <>{Heading}</>
          </h3>
          <div className="repaymentPlan__row">
            {(typeof DiscountedDebtBalanceRaw !== 'undefined' && DiscountedDebtBalanceRaw > 0) && (
              <>
                <div className="repaymentPlan__column">
                  <span className="repaymentPlan__label">
                    <>{BalanceLabel}</>
                  </span>
                  <span className="repaymentPlan__totalPayment">
                    {typeof BalanceAmount !== 'undefined' && (
                      typeof BalanceAmount === 'string' ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: BalanceAmount,
                          }}
                        />
                      ) : (
                        <span>
                          {FormatMoney(
                            BalanceAmount,
                            Currencysymbol,
                            IsCurrencyOnTheLeftSide,
                            Decimalseparator,
                          )}
                        </span>
                      )
                    )
                    }
                  </span>
                </div>
                <div className="repaymentPlan__column">
                  <span className="repaymentPlan__label">
                    <>{DiscountBalancelabel}</>
                  </span>
                  <span className="repaymentPlan__totalPayment discountValue">
                    {typeof DiscountBalanceAmount !== 'undefined' && (
                      typeof DiscountBalanceAmount === 'string' ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: DiscountBalanceAmount,
                          }}
                        />
                      ) : (
                        <span>
                          {FormatMoney(
                            DiscountBalanceAmount,
                            Currencysymbol,
                            IsCurrencyOnTheLeftSide,
                            Decimalseparator,
                          )}
                        </span>
                      )
                    )}
                  </span>
                </div>
              </>
            )}
            <div className="repaymentPlan__column">
              <span className="repaymentPlan__label">
                <>{Monthlylabel}</>
              </span>
              <span
                className={
                  'em repaymentPlan__monthlyPayment ' + hasLimitClass
                }
              >
                {NumberofMonth && (
                  <span>
                    {NumberofMonth} x {' '} 
                  </span>
                )}
                {typeof Mothlyamount !== 'undefined' && Mothlyamount !== null && (
                  typeof Mothlyamount === 'string' ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: Mothlyamount,
                      }}
                    />
                  ) : (
                    <span className={styles.spanMonthlyPaymentAlignment}>
                      {FormatMoney(
                        Mothlyamount,
                        Currencysymbol,
                        IsCurrencyOnTheLeftSide,
                        Decimalseparator,
                      )}
                    </span>
                  )
                )}
              </span>
            </div>
            <div className="repaymentPlan__column">
              <span className="repaymentPlan__label">
                <>{Finallabel}</>
              </span>
              <span className="repaymentPlan__totalPayment">
                {typeof FinalAmount !== 'undefined' && FinalAmount !== null && (
                  typeof FinalAmount === 'string' ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: FinalAmount,
                      }}
                    />
                  ) : (
                    <span>
                      {FormatMoney(
                        FinalAmount,
                        Currencysymbol,
                        IsCurrencyOnTheLeftSide,
                        Decimalseparator,
                      )}
                    </span>
                  )
                )}
              </span>
            </div>

            {PaymentMethod && (<div className="repaymentPlan__column">
              <span className="repaymentPlan__label">
                <>{PaymentMethodLabel}</>
              </span>
              <span className={'em repaymentPlan__monthlyPayment ' + hasLimitClass}>

                <span
                  dangerouslySetInnerHTML={{
                    __html: PaymentMethod,
                  }}
                />

              </span>
            </div>)}

            {CustomerNumber && (<div className="repaymentPlan__column">
              <span className="repaymentPlan__label">
                <>{CustomerNumberLabel}</>
              </span>
              <span className={'em repaymentPlan__monthlyPayment ' + hasLimitClass}>

                <span
                  dangerouslySetInnerHTML={{
                    __html: CustomerNumber,
                  }}
                />

              </span>
            </div>)}

            <div className="repaymentPlan__column last_column">
              <span className="repaymentPlan__label ">
                <>{Totaltext}</>
              </span>
              <span className="repaymentPlan__totalPayment">
                {typeof Totalamount !== 'undefined' && Totalamount !== null && (
                  typeof Totalamount === 'string' ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: Totalamount,
                      }}
                    />
                  ) : (
                    <span>
                      {FormatMoney(
                        Totalamount,
                        Currencysymbol,
                        IsCurrencyOnTheLeftSide,
                        Decimalseparator,
                      )}
                    </span>
                  )
                )}
              </span>
            </div>
          </div>

          {PlanDueDate && <div
            className={classNames(styles.para, styles.infoTextBottom)}
            dangerouslySetInnerHTML={{
              __html: planDueDateTemplate
                ? planDueDateTemplate({
                  PaymentPlanDueDate: PlanDueDate,
                })
                : '',
            }} />}
        </div>

      </section>
    </>
  );
};

export default RepaymentList;
